export default "__VITE_ASSET__Dhz8Cc8B__"